import React, { useRef, useEffect } from 'react';
import TypeIt from 'typeit';

type TextSlideShowProps = {
    steps: string[],
};

const TextSlideShow: React.FC<TextSlideShowProps> = ({ steps }) => {
    const textSlideShowRef = useRef(null);

    useEffect(() => {
        const slider = new TypeIt(
            textSlideShowRef.current, { speed: 10, startDelay: 0, waitUntilVisible: false }
        );
          
        slider.options({speed: 100, deleteSpeed: 0});

        steps.forEach((slide: string, index: number) => {
            const isLastMessage = index + 1 === steps.length;
            const freezeTime = 12000;

            slider.type(slide)

            if (!isLastMessage) {
                slider.pause(freezeTime).delete();
            }
        });

        slider.go();
    }, []);

    return <b className="text-slide-show" ref={textSlideShowRef} />;
};

export default TextSlideShow;